// extracted by mini-css-extract-plugin
export var category = "index-module--category--KUrFl";
export var date = "index-module--date--bscCI";
export var date_category = "index-module--date_category--rqsi0";
export var featured_blogs_container = "index-module--featured_blogs_container--XR+Aw";
export var text_container = "index-module--text_container--ehRIQ";